import { render, staticRenderFns } from "./CartPaymentsPoints.vue?vue&type=template&id=0b200875&scoped=true"
import script from "./CartPaymentsPoints.vue?vue&type=script&lang=js"
export * from "./CartPaymentsPoints.vue?vue&type=script&lang=js"
import style0 from "./CartPaymentsPoints.vue?vue&type=style&index=0&id=0b200875&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b200875",
  null
  
)

export default component.exports